/*!
=========================================================
* 調査一覧
=========================================================
*/
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock,faLockOpen } from "@fortawesome/free-solid-svg-icons";


import {
  Button,
  Col,
  FormGroup,
  Input,Row,
  Card,  CardHeader, CardBody,  CardTitle,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import { Link } from 'react-router-dom';
import Request from '../../common/Request';

import DialogBase from '../Base/DialogBase';
import ListBase from '../Base/ListBaseUnlimitSubComponent';
import Definition from '../../common/Definition';
import Format from '../../common/Format';
import FormatCode from '../../common/FormatCode';
import OptionConvert from '../../common/OptionConvert';

import InputText from '../FormParts/InputText'
import InputDatetime from '../FormParts/InputDatetime'
// import ButtonWithRole from '../FormParts/ButtonWithRole';
import InputSelect from '../FormParts/InputSelect'
import InputCheckBox from '../FormParts/InputCheckBox'
import MemoPopup from "../ViewParts/MemoPopup";
import WithRole from '../FormParts/ButtonWithRole';

import 'moment/locale/ja'
import moment from 'moment/moment'
import GsuiteAuth from '../../components/Auth/GsuiteAuth';

import {GetMessage, getErrorCodes} from "../../variables/message"
import {
  cst_survey_status,
  cst_request_box_status,
  REQUEST_BOX_STATUS,
  SURVEY_STATUS,
  ESTIMATE_STATUS,
  ORDER_BOX_STATUS
} from '../../variables/codes_map';

import { RequestInfoDetail } from "../ViewParts/RequestInfoDetail";
import format_url from '../../variables/format_url';
import GoogleDrive from  "../../common/GoogleDrive"
import AddMemoPopup from "../ViewParts/AddMemoPopup";
import Validate from "../../common/Validate";
import CsvDownloader from "react-csv-downloader";
import { SURVEY_CSV } from '../../variables/csv'
import custom_report from "../../variables/custom_report"

moment.locale('ja')

moment.updateLocale('ja', {
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
});

class List extends ListBase {

  default_column = [
    { Header: '案件ID',accessor: '___JOIN__REQUEST__request_natural_id',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50,sortable:false},
    { Header: '見積提出期限',accessor: 'REQUEST__estimate_deadline',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
    { Header: '利用開始日',accessor: 'REQUEST__want_start_date',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
    { Header: '依頼内容',accessor: '___JOIN_REQUEST_request_survey_status',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50,sortable:false},
    { Header: '顧客情報',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50,sortable:false},
    { Header: '現場名/工事番号/現場住所/現場担当者',accessor: '___JOIN_project_information_addr',headerClassName:'text-center',className:'text-left text-top',width:280,minWidth:50,sortable:false},
    { Header: '調査担当者',accessor: '___JOIN_REQUEST__survey_account',headerClassName:'text-center',className:'text-left text-top',width:250,minWidth:150,sortable:false},
    ];

  // ボタンのクラス
  button_class="MuiButtonBase-root MuiButton-root MuiButton-text btn btn-secondary btn-facebook margin"

  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '調査一覧',
      add_url: '',
      search_url: '/api/request/unlimit',
      with_all_check: true, //チェックボックス表示
      mode: 0,//表示設定 1:非表示
      show_detail_search_field:true,
      REQUEST__request_natural_id: "",
      PROJECT__site_address: "",
      REQUEST__onsite_survey_account: "",
      REQUEST__lastupdate_user_id: "",
      REQUEST__estimate_deadline: "",
      lastUserList:[],
      searchData:{
        values:{
          // 0:未着手、1:返答待ち、2:チェック、3:チェックOK
          request_box_status : this.checkBoxStatus(this.props.box_status)
        },
        errors:{},
        requiredData:{}
      },
      surveyData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      Data:{
        values:{
          // 初期表示検索条件
          request_box_status : this.checkBoxStatus(this.props.box_status)
        },
        errors:{},
        requiredData:{}
      },
      column: this.default_column,
      detail_search:false,
      valid: true,
      landmark_user:[],
      custCancelCount : 0,
      auto_scroll:true, // 自動スクロールフラグ
      modalReEstimate : false, // 再見積ダイアログ表示フラグ
      modalEditEstimate : false, // 見積編集ダイアログ表示フラグ
      modalSendEstimate : false, // 見積送付ダイアログ表示フラグ
      modalAutoOrder : false, // 自動発注ダイアログ表示フラグ
      editRoutemapFlag : false, //経路図編集フラグ初期値 off
      reEstimateData : undefined,
      sendEstimateData : {
        values:{
          send_upload_notification: false,
          no_send_fax : false,
        },
        errors:{},
        requiredData:{}
      },
      editEstimateData : undefined,
      subComponent: this.subComponent,
      addMemoPopupData:{},//メモPOPUP用
      expanded:[],
      customerList : [],
      customerBranchList : [],
    });

    this.memoPopup = React.createRef();
    this.dialogCancelConfirm = React.createRef();
    this.dialogCustomerRequestFile = React.createRef();

    this.validateCallback = this.validateCallback.bind(this)
    this.getButtonName = this.getButtonName.bind(this)
    this.dataMap = this.dataMap.bind(this)
    this.search = this.search.bind(this)
    this.validate = this.validate.bind(this)
    this.initializeSurvey = this.initializeSurvey.bind(this)
    this.search_count = this.search_count.bind(this)

    this.modalReEstimate = this.modalReEstimate.bind(this)
    this.modalEditEstimate = this.modalEditEstimate.bind(this)
    this.modalSendEstimate = this.modalSendEstimate.bind(this)
    this.modalAutoOrder = this.modalAutoOrder.bind(this)
    this.onClickReEstimateModal = this.onClickReEstimateModal.bind(this)
    this.onClickEditEstimateModal = this.onClickEditEstimateModal.bind(this)
    this.onClickSendEstimateModal = this.onClickSendEstimateModal.bind(this)
    this.validateCallbackForSend = this.validateCallbackForSend.bind(this)
    this.validateCallbacSurveyData = this.validateCallbacSurveyData.bind(this)
    this.sendEstimate = this.sendEstimate.bind(this)
    this.autoOrder = this.autoOrder.bind(this)
    this.subComponent = this.subComponent.bind(this)
    this.addMemoPopup = React.createRef()
    this.onClickOrderMemo = this.onClickOrderMemo.bind(this)
    this.onClickSupplierMemo = this.onClickSupplierMemo.bind(this)
    this.memoPopupAction= this.memoPopupAction.bind(this)
    this.contactMemoAction= this.contactMemoAction.bind(this)
    this.dialogSurveyCsvDownload = React.createRef();

    this.customerUseCustomizedEstimate = custom_report.estimate.survey["アイダ設計"].customer_natural_id // アイダ設計
    this.customerUseCustomizedEstimateForTouken = custom_report.estimate.survey["東建コーポレーション"].customer_natural_id // 東建コーポレーション
    this.customerUseCustomizedEstimateForTaiseiHousing = custom_report.estimate.survey["大成建設ハウジング"].customer_natural_id // 大成建設ハウジング
    this.customerUseCustomizedEstimateForTaiseiHousingBranch = custom_report.estimate.survey["大成建設ハウジング"].customer_branch_natural_id // 大成建設ハウジング 東海・九州
    this.customerUseCustomizedEstimateForTaiseiHousingBranch2 = custom_report.estimate.survey["大成建設ハウジング"].customer_branch_natural_id_2 // 大成建設ハウジング 近畿
    
  }

  // テーブルのサブコンポーネント
  subComponent = (row) =>{    
    return <RequestInfoDetail data={row}/>
  }

  // メニューのBoxStausを検索条件に変換する。
  // チェックは、チェックNGと共存するため
  checkBoxStatus(box_status){
    switch (Number(box_status)) {
      case REQUEST_BOX_STATUS.NOT_YET://提案.未着手
        return [REQUEST_BOX_STATUS.NOT_YET]
      case REQUEST_BOX_STATUS.WAITING_APPLY://提案.返答待ち
        return [REQUEST_BOX_STATUS.WAITING_APPLY]
      case REQUEST_BOX_STATUS.CHECK://提案.チェック
        return [REQUEST_BOX_STATUS.CHECK,REQUEST_BOX_STATUS.CHECK_NG]
      case REQUEST_BOX_STATUS.CHECK_OK://提案.チェックOK
        return [REQUEST_BOX_STATUS.CHECK_OK]
      default:
        return []
    }
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      const user_list = OptionConvert.options(res.Data)
      const landmark_user = OptionConvert.optionsById(res.Data)

      //【2020/12/09-06】 調査一覧画面にステータス検索条件追加
      const employee_type = GsuiteAuth.get('employee_type')
      const survey_status = employee_type === "4" ? ["2"] : ["0","1","2","3"]

      this.setState({
        lastUserList:user_list,
        landmark_user,
        searchData : {
          ...this.state.searchData,
          values : {
            ...this.state.searchData.values,
            survey_status,
            register_type: 0
          }
        },
        subComponent: this.subComponent,
      },()=>this.search(false));
    })

    Request.get("/api/landmark/user_branch",{}, res => {
      const user_branch_list = res.Data.map((data)=>{
        return {
            value:data.user_branch_natural_id,
            label:data.user_branch_name,
        }
      })
      this.setState({landmark_user_branch:user_branch_list});
    })
    // 顧客会社名のリスト取得
    Request.get("/api/customer",{without_limit:true}, res => {
			const customerList = res.Data.map(element=>{
			  return {
          value:element.ulid,
          label:element.customer_name
			  }
			})
			this.setState({customerList});
		})
  }  

  // 顧客用メモ,仕入先メモ表示用
  memoPopupAction = (prop, isOrderMemo) => {
    this.setState({
      addMemoPopupData : {
        values : prop.row,
        isOrderMemo: isOrderMemo,
        label: isOrderMemo?"顧客メモ":"仕入先メモ",
      }
    }, () => { this.addMemoPopup.current.show() })
  }

  //メモ更新API呼び出し
  updateEstimateMemo(data, isOrderMemo){
    const ulid = data.ulid
    const url = '/api/estimate/memo/'+ ulid
    const params = {
      add_memo: data.add_memo,
      isOrderMemo: isOrderMemo,
      update_timestamp: data.update_timestamp,
      login_user: localStorage.getItem("name")
    }
    Request.patch(url, params, (res)=>{
      // サブコンポーネントのエレメントを再取得し
      // 関数を実行させる。ここではデータを再取得させている
      document.getElementById(ulid).click();
    })
  }

  // 顧顧客への連絡欄表示用
  contactMemoAction(prop){
    this.setState({
      memoPopupData : {
        values : prop
      }
    }, () => { this.memoPopup.current.show() })
  }

  clickCustomerRequestFile(prop){
    console.log("clickCustomerRequestFile", prop);
    this.setState({
      dialogCustomerRequestFileData:{
        ...this.state.dialogCustomerRequestFileData,
        values:prop,
      }
    }, () => { this.dialogCustomerRequestFile.current.show() })
  }

  dataMap(data) {
    const button_class = this.button_class;
    const user_list = this.state.lastUserList;
    return data.map((prop, key) => {
      const matchedUser = user_list.find((singleUser)=>singleUser.id===prop.lastupdate_user_id)
      const rootData = {
        values:prop,
        errors:{},
        requiredData:{}
      }
      const lastupdate_user = matchedUser ? (
        {
          name:matchedUser.label,
          picture:matchedUser.picture,
          ulid:matchedUser.id,
          id:matchedUser.value
        }
      ):(
        {
          name:"",
          picture:"",
          ulid:"",
          id:""
        }
      )
      
      const prop_tmp = {user_name:lastupdate_user.name, update_timestamp:prop.update_timestamp};
      const survey_account = prop.web_user_name ? prop.web_user_name : prop.onsite_user_name
      const auto_order = prop.auto_order_display_flag == 1 && prop.auto_order_function_flag == 1 && prop.auto_order_execution_flag == 1

      let disp_status = "";
      // 調査ステータスが依頼キャンセルの場合のみ、表示を依頼BOXステータスとは別にする
      if(prop.survey_status === SURVEY_STATUS.CANCEL_REQUEST){
        disp_status = FormatCode.decode("cst_survey_status", prop.survey_status);
      }else{
        disp_status = FormatCode.decode("request_box_status", prop.request_box_status);
      }

      return {
        // 背景色設定用
        rowColor: this.getRowColorClass(prop),
        id: key,
        REQUEST__request_natural_id: prop.request_natural_id,
        PROJECT__project_id: prop.project_id,
        REQUEST__ulid: prop.ulid,
        ___JOIN__REQUEST__request_natural_id: (<>
        <Link target="_blank" to={"/construction/parking/detail/" + prop.ulid} color="facebook">
        {`${prop.register_type==1 ? "(*)":""}${prop.request_natural_id}`}
        </Link>
        <br></br>{disp_status} 
        </>
        ),
        ___JOIN_request: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_request', prop)}} />,
        ___JOIN_client_master: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />,
        ___JOIN_project_information_addr: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_information_addr_with_site_customer', prop)}} />,
        // 下請
        ___JOIN_subcontract_customer_information: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_subcontract_customer_information_line', prop)}} />,
        ___JOIN_project_addr: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_addr', prop)}} />,
        ___JOIN_REQUEST_request_survey_status: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_REQUEST_request_survey_status', prop)+"<br />"+Format.format_date_range_yymmdd(prop.want_start_date, prop.want_end_date)}} />,
        REQUEST__request_date: Format.format_date_yymmdd(prop.request_date),
        REQUEST__want_start_date: Format.format_date_yymmdd(prop.want_start_date),
        // 利用期間
        ___JOIN_REQUEST__want_period_of_use: Format.format_date_range_yymmdd(prop.want_start_date, prop.want_end_date),
        REQUEST__survey_status: FormatCode.decode("survey_status",prop.survey_status),
        ___JOIN_request_update: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_request_update', prop_tmp)}} data4Sort={prop_tmp.update_timestamp} />,
        REQUEST__estimate_deadline: <span style={{color:"red", fontWeight:900}}>{Format.format_date_yymmdd(prop.estimate_deadline)}</span>,
        actions_1: (
          (prop.request_box_status == REQUEST_BOX_STATUS.NOT_YET || prop.request_box_status == REQUEST_BOX_STATUS.WAITING_APPLY) &&
          <Button disabled={prop.survey_status == 10} size="sm" onClick={() => { this.handleSurveyActionClick(prop) }} className={button_class}>{this.getButtonName(prop.survey_status)}</Button>),
        actions_2: (
          (prop.request_box_status == REQUEST_BOX_STATUS.NOT_YET || prop.request_box_status == REQUEST_BOX_STATUS.WAITING_APPLY) &&
          prop.estimate_copy_flag === 1 && <Button size="sm" onClick={() => {
          this.onClickReEstimateModal(prop)
        }} className={button_class}>{"再見積"}</Button>),
        // 依頼.調査ステータスが10:調査キャンセルではない、かつ
        // 見積.見積ステータスが0:調査見積未作成、1:調査見積作成済み、2:経路図作成済のとき表示
        actions_3: (
          prop.survey_status !== 10 && 
          (prop.request_box_status == REQUEST_BOX_STATUS.CHECK || prop.request_box_status == REQUEST_BOX_STATUS.CHECK_NG ) &&
           <Button size="sm" onClick={() => { 
          this.onClickEditEstimateModal(prop)
        }} className={button_class}>{"見積編集"}</Button>),
        actions_send_estimate:(
          prop.survey_status !== 10 && 
          prop.request_box_status == REQUEST_BOX_STATUS.CHECK_OK &&
        <><Button size="sm" onClick={() => { 
          this.onClickSendEstimateModal(prop, auto_order)
        }} className={button_class}  disabled={!(this.checkSendEstimate(prop))}>{auto_order ? "自動発注" : "見積送付"}</Button>
        {!this.checkSendEstimate(prop)?<><span style={{color:"red", fontWeight:900}}>未承認の顧客情報があります</span></>:<></>}
        </>
        ),
        // feature/1590 顧客システム連携添付ファイル
        actions_customer_request_file:(<Button size="sm" disabled={prop.customer_request_file_flag == 0}  className={button_class} onClick={()=>{
          this.clickCustomerRequestFile(prop);
        }}>{"添付ファイルダウンロード"}</Button>),
        actions_check_ok_estimate:(
          prop.survey_status !== 10 &&
           (prop.request_box_status == 2 || prop.request_box_status == REQUEST_BOX_STATUS.CHECK_NG ) &&
            <Button size="sm" onClick={() => { 
          this.onClickChangeBoxRequest(prop, REQUEST_BOX_STATUS.CHECK_OK)
        }} className={button_class}>{"チェックOK"}</Button>
        ),
        actions_check_ng_estimate:(
          prop.survey_status !== 10 &&
           (prop.request_box_status == 2 || prop.request_box_status == REQUEST_BOX_STATUS.CHECK_OK ) &&
            <Button size="sm" onClick={() => { 
          this.onClickChangeBoxRequest(prop, REQUEST_BOX_STATUS.CHECK_NG)
        }} className={button_class}>{"チェックNG"}</Button>),
        actions_cancel_confirm : (<Button disabled={!(prop.survey_status == 10 && prop.request_cancel_check_flag == 0)} size="sm"
          onClick={()=>this.setCancelConfirmDialog(prop)} className={button_class}>キャンセル確認</Button>),
        REQUEST__customer_other_request: prop.customer_other_request,
        REQUEST__survey_report: prop.survey_report,
        REQUEST__request_box_status: prop.request_box_status,
        // // 顧客への連絡欄
        // REQUEST__contact_memo: (<Input type={"textarea"} value={prop.contact_memo} disabled={true}></Input>),
        // // 顧客への連絡欄Popup
        // actions_contact_memo:(<Button size="sm"
        // onClick={()=>this.contactMemoAction(prop)} className={button_class}>顧客への連絡事項</Button>),
         // 顧客支店メモ
        REQUEST__customer_branch_system_memo:prop.customer_branch_system_memo,
        // ロックボタン表示フラグ
        REQUEST__survey_account_user_lock_flag: prop.survey_account_user_lock_flag,
        addMemo: this.memoPopupAction,
       //ロック+名前
       ___JOIN_REQUEST__survey_account:(
        <>
		      調査&nbsp;
          <FontAwesomeIcon 
            className="hover" 
            onClick={(e)=>{this.onClickLock(prop)}} 
            icon={prop.survey_account_user_lock_flag==0? faLockOpen: faLock}
          />&nbsp;
          <InputSelect
            label="調査担当者"
            className="select-user-box"
            name="REQUEST__web_survey_account"
            labelOn={false}
            options={this.state.landmark_user}
            validateCallback={(newData)=>{(this.validateCallbackSurveyAccount(newData))}}
            rootData={rootData}
            isSearchable={true}
            menuPosition={"fixed"}
            validateType={'regist'}
            disabled={prop.survey_account_user_lock_flag==0?false:true}
          /><br></br>
          <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_request_update_line', prop_tmp)}} data4Sort={prop_tmp.update_timestamp} />
</>
        
       ),
      }
    })
  }

  // 背景色のクラスを設定する
  getRowColorClass(data){
    // 顧客システムからの登録か
    const isCustomer = data.register_type == "1" ? true: false;
    // ステータスはNGか
    const isCheckNg = data.request_box_status == REQUEST_BOX_STATUS.CHECK_NG ? true: false;
    // 自動発注
    // console.log(data)
    const isAutoOrder = data.auto_order_display_flag == 1 && data.auto_order_function_flag == 1 && data.auto_order_execution_flag == 1 ? true: false;

    if (isCheckNg){
      return "bg-lred"
    } else if (isAutoOrder) {
      return "bg-lyellow"
    } else if (isCustomer){
      return "bg-lblue"
    }
    return ""
  }

  // 見積送信ボタンの条件を確認する
  // 顧客情報が全て承認済であること
  checkSendEstimate(data){
      return this.isCheckSendEstimateCustomer(data)
  }

  // 顧客情報が全て承認済であること
  // return true:承認済み
  isCheckSendEstimateCustomer(data){
    if (
      data.customer_sales_department_agreement_flag === 1 && 
      data.customer_management_department_agreement_flag === 1 && 
      data.customer_branch_manager_agreement_flag === 1 && 
      data.customer_branch_sales_department_agreement_flag === 1 && 
      data.customer_branch_management_department_agreement_flag === 1 && 
      data.customer_branch_branch_manager_agreement_flag === 1 && 
      data.customer_user_sales_department_agreement_flag === 1 && 
      data.customer_user_management_department_agreement_flag === 1 && 
      data.customer_user_branch_manager_agreement_flag === 1) {
      return true
    }
    return false
  }


  // 担当者ロック更新
  onClickLock(prop){
    const lock_flag = prop.survey_account_user_lock_flag == 1?0:1
    const url = "/api/request/" + prop.ulid
    const params = {
      survey_account_user_lock_flag : lock_flag,
    }
    Request.patch(url, params,
      res => {
        if(res.Code === 200) {
          this.search()
        }
      }
    )
  }

  // ステータス更新
  onClickChangeBoxRequest(prop, request_box_status){
    // 2522: 'チェックOKに変更しますがよろしいですか?',
    // 2523: 'チェックNGに変更しますがよろしいですか?',
    let messageNo
    switch (request_box_status) {
      case REQUEST_BOX_STATUS.CHECK_OK:
        messageNo = 2522;
        break;
      case REQUEST_BOX_STATUS.CHECK_NG:
        messageNo = 2523;
        break;
    }
    this.props.alertModal.current.confirmCheck({messageNo},()=>{
      const url = "/api/request/"+prop.ulid
      const params = {
        request_box_status : request_box_status
      }
      Request.patch(url, params,
        res => {
          if(res.Code === 200) {
            this.search()
          }
        }
      )
    })
  }

  onClickReEstimateModal (prop) {
    this.setState({
      reEstimateData:prop,
      modalReEstimate : true
    })
  }

  onClickEditEstimateModal (prop) {
    this.setState({
      editEstimateData:prop,
      modalEditEstimate : true
    })
  }

  onClickSendEstimateModal (prop, auto_order=false) {
    if(auto_order) {
      // 自動発注
      this.setState({
        sendEstimateData : {
          values : {
            ...prop
          },
        },
        modalAutoOrder : true
      })
    } else {
      this.setState({
        sendEstimateData : {
          values : {
            ...prop
          },
        },
        modalSendEstimate : true
      })
    }

  }

  // 再見積
  reEstimate(){
    let request = this.state.reEstimateData

    if (request == undefined) return

    const searchParmas = {
      request_ulid : request.ulid,
      search_distance: request.request_type == 3 ? 20000 : 3000  ,
      latitude: request.latitude,
      longitude: request.longitude,
      re_estimate_flag : true
    }

    Request.get("/api/request/parking/unlimit", searchParmas, res => {
      const copyRequestParkings = res.Data;
      copyRequestParkings.sort((a, b) => a.request_parking.site_distance_meter - b.request_parking.site_distance_meter)

        // 経路図編集→あり
        if ( this.state.editRoutemapFlag ) {
          this.props.history.push({
            pathname:"/route-map/route_edit", 
            state: {
              ulid : request.ulid,
              parking : copyRequestParkings,
              full_parking : []
            }
          });
        }
        // 経路図編集→なし
        else {
          const ulids = copyRequestParkings.map((item)=>['ulid', item.request_parking.ulid])
          const params = new URLSearchParams(ulids);
          this.props.history.push({
            pathname: '/survey/estimate/add', 
            search: '?' + params.toString() + `&request_ulid=${request.ulid}` ,
            state : {
              copyRouteMap : true, 
              parking : copyRequestParkings,
            }
          });
        }
    })
  }

  editEstimate(){
    let request = this.state.editEstimateData
    console.log("editEstimate")
    console.log(this.state.editEstimateData)
    if (request == undefined) return

    const searchParmas = {
      request_ulid : request.ulid,
      search_distance: request.request_type == 3 ? 20000 : 3000  ,
      latitude: request.latitude,
      longitude: request.longitude
    }

    Request.get("/api/request/parking/cart", searchParmas, res => {
      const copyRequestParkings = res.Data;
      copyRequestParkings.sort((a, b) => a.request_parking.site_distance_meter - b.request_parking.site_distance_meter)
      // 経路図編集フラグ判定
      if ( this.state.editRoutemapFlag ) {
        //経路図編集→あり 
        this.props.history.push({
          pathname:"/route-map/route_edit/edit", 
          state: {
            ulid : request.ulid,
            parking : copyRequestParkings,
            full_parking : [],
            mode: 'edit'
          }
        });
      } else {
        // 経路図編集→なし
        const ulids = copyRequestParkings.map((item)=>['ulid', item.request_parking.ulid])
        const params = new URLSearchParams(ulids);
        this.props.history.push({
          pathname: '/survey/estimate/edit', 
          search: '?' + params.toString() + `&request_ulid=${request.ulid}` ,
          state : {
            copyRouteMap : true, 
            parking : copyRequestParkings,
          }
        });
      }
    })
  }

  validateCallbackForMemo(newData, prop, key, name, type){
    this.setState({
      data : [
        ...this.state.data.slice(0, key),
        {
          ...this.state.data[key],
          [name] : {
            ...this.state.data[key][name],
            props : {
              ...this.state.data[key][name].props,
              rootData : newData
            }
          }
        },
        ...this.state.data.slice(key+1),
      ]
    })
    if(Object.keys(newData.errors).length > 0){
      return;
    }
    const originMemo = this.state.data[key][name].props.rootData.values[type];
    if ( originMemo == newData.values[type]
      || (originMemo == null && newData.values[type] == "")) {
      return;
    }

    const url = '/api/request/memo/'+prop.ulid
    const params = {
      ...prop,
      [type]:newData.values[type]
    }
    Request.put(url, params, (res)=>{
      // this.search(); // メモ更新時は再検索しない
    })
  }

  updateMemo(data){
    // 無効な文字列チェック
		const max_length_validate = Validate.length(data.contact_memo, "", "text_ja_20000")
		if(!max_length_validate.valid){
      this.props.alertModal.current.showErrorModal({message:max_length_validate.message});
			return;
		}

    const url = '/api/request/memo/'+data.ulid
    const params = {
      ...data,
    }
    Request.put(url, params, (res)=>{
      this.search();
    })
  }

  getButtonName(status){
    switch(status){
      case 0:
      case 1:
        return '調査'
      case 2:
        return '調査'
      case 3:
        return '調査'  
      default:
        return '依頼キャンセル'
    }
  }

  initializeSurvey(prop){
    var url = '/api/request/parking/initialize';
    const params = {
      initialize_survey: true,
      request_ulid: prop.ulid,
      request_natural_id: prop.request_natural_id,
      project_id: prop.project_id,
      project_natural_id: prop.project_natural_id,
      customer_id: prop.customer_id,
      customer_natural_id: prop.customer_natural_id,
      customer_branch_id: prop.customer_branch_id,
      customer_branch_natural_id: prop.customer_branch_natural_id,
      customer_user_id: prop.customer_user_id,
      customer_user_natural_id: prop.customer_user_natural_id,
      search_distance: 3,
      user_branch_id: GsuiteAuth.get('user_branch_id'),
      user_branch_natural_id:GsuiteAuth.get('user_branch_natural_id'),
      user_id: GsuiteAuth.get('id'),
      update_timestamp: prop.update_timestamp
    };
    console.log(prop)
    Request.post(url, params, (res) => {
      if (res.Code===200){
        this.props.history.push("/survey/detail/"+prop.ulid)  
      }
    },(err)=>{
      const {status, statusText} = err.response
      this.props.alertModal.current.showErrorModal({title:status, message:statusText});
    },undefined,true,true);
  }

  handleSurveyActionClick(prop){
    if (prop.estimate_create_start_date || prop.estimate_copy_flag == 1){
      const date = new Date(prop.estimate_create_start_date)
      const message = prop.estimate_copy_flag == 1
        ? GetMessage(2491) 
        : Format.dateToString(date, 'YYYYMMDD hh:mm:ss')+GetMessage(2463)
      this.props.alertModal.current.confirmCheck(
        {
          message:message
        },
        ()=>{
          Request.put("/api/request/"+prop.ulid, {
            ...prop,
            estimate_create_start_date:null
          }, (res) => {
            this.initializeSurvey({
              ...prop,
              update_timestamp:res.Data.update_timestamp
            })
          },(err)=>{
            const {status, statusText} = err.response
            this.props.alertModal.current.showErrorModal({title:status, message:statusText});
          },undefined,true,false)
        }
      )
      return
    } else {
      this.initializeSurvey(prop)
    }
  }

  setCancelConfirmDialog(request){
    this.setState({
      dialogCancelConfirmData:{
        ...this.state.dialogCancelConfirmData,
        values:request,
      }
    }, () => { this.dialogCancelConfirm.current.show() })
  }

  search_params() {
    const {values} = this.state.searchData

    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
 
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  search(refreshTaskFlag = true) {
    // console.log("search");
    /* ここは開発者が記述 */
    if (!this.validate()) {
        // do nothing
        return;
    }
    this.search_count();
    var search_param = this.search_params();
    search_param["pager_index"] = "0";
    search_param["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      search_param, 
      res => {
          this.setState({
            paging: {
              "index": parseInt(search_param["pager_index"]),
              "limit": parseInt(search_param["pager_limit"])
            },  
            data: this.dataMap(res.Data)
          });
    })

    // 依頼キャンセル件数取得
    var search_param_cancel = this.search_params();
    search_param_cancel["data_count"] = 1;
    search_param_cancel["survey_status"] = [10];
    Request.get(this.state.search_url, search_param_cancel
      , res => {
          this.setState({
              custCancelCount : res.Data || 0
          });
    })
    
    if(refreshTaskFlag){
      this.props.refreshTaskCount()
    }
  }

  /* #1168 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        this.setState({data_count: res.Data});
    })
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  async validateCallback(newData, callback=()=>{}){

    const employee_type = GsuiteAuth.get('employee_type')
    let survey_status=[]
    // 依頼キャンセルがONの場合
    const survey_status_cancel = newData.values.survey_status_cancel?newData.values.survey_status_cancel:0
    if (survey_status_cancel == 1){
      survey_status = ["10"]
    } else {
      survey_status = employee_type === "4" ? ["2"] : ["0","1","2","3"]
    } 
    newData.values.survey_status = survey_status

    if(newData.values.customer_name != undefined || newData.values.customer_ulid != undefined){
      // 顧客会社名
			const customerParam = (this.state.customerList.findIndex(customer=>customer.value==newData.values.customer_ulid)>-1)
			? {
			  customer_ulid: newData.values.customer_ulid,
			  customer_name: undefined
			} : {
			  customer_ulid:undefined,
			  customer_name: (newData.values.customer_ulid != undefined)?newData.values.customer_ulid:newData.values.customer_name
			}
      
      // 顧客支店名リスト（詳細検索：顧客会社名でリスト選択時に顧客支店名のリスト取得）
			const customerBranchList = this.state.searchData.values.customer_ulid!=customerParam.customer_ulid
			? (customerParam.customer_ulid
			  ? await new Promise(resolve=>{
				Request.get("/api/customer/branch",{
				  customer_ulid:customerParam.customer_ulid,
				  customer_branch_delete_flag : 1
				}, res => {
				  resolve(res.Data.map(element=>{
					return {
					  value:element.ulid,
					  label:element.customer_branch_name
					}
				  })) 
				})
			  })
			  : [])
			: this.state.customerBranchList
			const customerBranchParam = this.state.searchData.values.customer_ulid==customerParam.customer_ulid
			? (customerBranchList.findIndex(customer=>customer.value==newData.values.customer_branch_ulid)>-1)
			  ? {
				customer_branch_ulid: newData.values.customer_branch_ulid,
				customer_branch_name: undefined
			  }
			  : {
				customer_branch_ulid: undefined,
				customer_branch_name: (newData.values.customer_branch_ulid != undefined)? newData.values.customer_branch_ulid:newData.values.customer_branch_name
			  }
			: {
			  customer_branch_ulid: undefined,
			  customer_branch_name: undefined
			}

      this.setState({
			  searchData:{
				...this.state.searchData,
				...newData,
				values:{
					...this.state.searchData.values,
					...newData.values,
					...customerParam,
					...customerBranchParam
				}
			  },
			  customerBranchList
			}, ()=>callback())
    }else{
			this.setState({
				searchData:{
				  ...this.state.searchData,
				  ...newData,
				  values:{
					  ...this.state.searchData.values,
					  ...newData.values,
				  }
				},
			  }, ()=>callback())
		}
  }

  search_field_cols() {
    return (
      <></>
      )
  }


  columnSelectUnderArea(){
    return <><Row><Col md="3">
    チェックした案件に設定する調査担当者
    </Col>
    <Col md="3">
    <InputSelect label="調査担当者"
    name="REQUEST__survey_account"
    labelOn={false} 
    validateCallback={this.validateCallbacSurveyData} 
    options={this.state.landmark_user}
    enterSearch={false}
    isSearchable={true}
    rootData={this.state.surveyData} />
    </Col>
    <Col md="3">
    <button onClick={()=>this.onClickChangeSurveyAccount()} className={this.button_class}>一括変更</button>
    </Col>
    <Col md="3"></Col>
    </Row></>;
   }

  validateCallbacSurveyData(newData, callback=()=>{}){
    this.setState({
      surveyData:{
        ...this.state.surveyData,
        ...newData
      }
    }, ()=>callback())
  }

  // 調査担当者一括変更Action
  onClickChangeSurveyAccount(){
    let messageNo = 2524
    let count = 0
    let lock_count = 0
    this.state.data.map( row => {

      if (row.checked == true && row.REQUEST__survey_account_user_lock_flag == 0){
        count++
      }
      if (row.checked == true && row.REQUEST__survey_account_user_lock_flag == 1){
        lock_count++
      }
    })

    messageNo = 2518
    //2518: 選択した依頼に調査担当者ロックされている依頼が含まれているため、登録することはできません。
    if (lock_count > 0) {
      this.props.alertModal.current.showErrorModal({messageNo});
      return 
    } 

    messageNo = 2524
    //2524: 'チェックされた案件がありません。チェックをオンにして実行してください。',
    if (count == 0) {
      this.props.alertModal.current.showErrorModal({messageNo});
      return 
    }

    //2525: '変更する調査担当者が選択されていません。担当者を選択して実行してください。',
    messageNo = 2525
    if (this.state.surveyData.values.survey_account?false:true){
      this.props.alertModal.current.showErrorModal({messageNo});
      return
    }
    
    //2526: '案件の調査担当者を変更しますがよろしいですか?',
    messageNo = 2526
    this.props.alertModal.current.confirmCheck({messageNo},()=>{
      // チェック済み,未ロックの場合変更可能
      this.state.data.map( row => {
        if (row.checked == true && row.REQUEST__survey_account_user_lock_flag == 0){
          const url = "/api/request/"+row.REQUEST__ulid
          const params = {
          survey_account: this.state.surveyData.values.survey_account
          }
          Request.patch(url, params,
            res => {
              if(res.Code === 200) {
                // this.props.alertModal.current.showErrorModal({messageNo});
                this.search()
              }
            }
          )
        }
      })
    })
  }

  // 調査担当者変更Callback
  validateCallbackSurveyAccount(newData){
    // チェック済み,未ロックの場合変更可能
    if (newData.values.survey_account_user_lock_flag == 0){
      const url = "/api/request/"+ newData.values.ulid
      const params = {
      survey_account: newData.values.web_survey_account
      }
      Request.patch(url, params,
        res => {
          if(res.Code === 200) {
            this.search()
          }
        }
      )
    }
  }

  search_field_cols() {
    return (
      <>
        <Col md="3">
          <InputSelect label="ランドマーク支店"
            name="REQUEST__user_branch_natural_id"
            labelOn={true} 
            validateCallback={this.validateCallback} 
            options={this.state.landmark_user_branch}
            enterSearch={true}
            enterCallback={this.searchWithPageIndex}
            rootData={this.state.searchData} />
        </Col>
        <Col md="3">
           <InputSelect label="調査担当者"
              name="REQUEST__survey_account"
              labelOn={true} 
              validateCallback={this.validateCallback} 
              options={this.state.landmark_user}
              enterSearch={true}
              enterCallback={this.searchWithPageIndex}
              isSearchable={true}
              rootData={this.state.searchData} />
        </Col>
        <Col md="3">
          <InputText
            label='案件ID'
            name='REQUEST__request_natural_id'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
      </>
    );
  }
  add_field_cols() {
    const {
      custCancelCount,
    } = this.state
    return (
	<>
    <Col md="3"></Col>
    <Col md="3">
      <div style={{paddingTop: "35px"}}>依頼キャンセル件数：{custCancelCount}</div>
    </Col>
	</>
    );
  }
  detail_search_field_btn(){
      return (<>
        </>);
  }
  detail_search_field_cols(){
    return (
      <>
        <Col md="11">
          <FormGroup>
            <InputCheckBox
              label='依頼キャンセル'
              name='REQUEST__survey_status_cancel'
              labelOn={false}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              checkedValue={1}
              uncheckedValue={0}
              validateType={'search'}
            />
            <InputCheckBox
              label='顧客向けシステムで登録されたデータ'
              name='PROJECT__register_type'
              labelOn={false}
              validateCallback={this.validateCallback}
              checkedValue={1}
              uncheckedValue={0}
              rootData={this.state.searchData}
              validateType={'search'}
            />
            <InputCheckBox
              label='調査担当者が設定されていないデータ'
              name='REQUEST__survey_account_none'
              labelOn={false}
              validateCallback={this.validateCallback}
              checkedValue={1}
              uncheckedValue={0}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputSelect
              label="顧客会社名"
              labelOn={true}
              name="CUSTOMER__customer_ulid"
              options={this.state.customerList}
              validateCallback={this.validateCallback} 
              validateType='search'
              isSearchable={true}
              isCreatable={true}
              rootData={this.state.searchData}
              searchStartLength={2}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputSelect
              label="顧客支店名"
              labelOn={true}
              key={`customer_branch_${this.state.searchData.values.customer_customer_ulid}`}
              name="CUSTOMER_BRANCH__customer_branch_ulid"
              options={this.state.customerBranchList}
              validateCallback={this.validateCallback} 
              validateType='search'
              rootData={this.state.searchData}
              isSearchable={true}
              isCreatable={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='顧客担当者TEL'
              name='CUSTOMER_USER__customer_user_tel'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='工事番号'
              name='PROJECT__construction_number'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='現場名'
              name='PROJECT__site_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='現場所在地'
              name='PROJECT__site_location'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='仕入先名'
              name='ESTIMATE__supplier_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='仕入先TEL'
              name='ESTIMATE__supplier_tel'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='駐車場名'
              name='ESTIMATE__survey_parking_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputText
              label='駐車場所在地（ 住所の方 ）'
              name='ESTIMATE__survey_parking_location'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputSelect label="最終更新者"
                name="REQUEST__lastupdate_user_id"
                labelOn={true} 
                validateCallback={this.validateCallback} 
                options={this.state.landmark_user}
                enterSearch={true}
                enterCallback={this.searchWithPageIndex}
                isSearchable={true}
                rootData={this.state.searchData} />        
          </FormGroup>
        </Col>
        <Col md="3"></Col>
        <Col md="3">
          <FormGroup>
            <InputDatetime
              label='依頼受付日（FROM）'
              name='ESTIMATE__request_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputDatetime
              label='依頼受付日（TO）'
              name='ESTIMATE__request_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出期限（FROM）'
              name='REQUEST__estimate_deadline_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出期限（TO）'
              name='REQUEST__estimate_deadline_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
      </>
    );
  }
  
  checkbox_field_cols(){
    return (
      <></>
    );
  }

  custom_field1(){
    const ButtonWithRole = WithRole(Button, this.props.buttons)
    return (
      <>
        <ButtonWithRole
          onClick={() => {
            this.setState({
              dialogTitle : "調査一覧CSV出力"
            }, () => {
              this.dialogSurveyCsvDownload.current.show()
            })
            console.log("clicked")
          }}
          // className="float-right"
        >
          調査一覧CSV出力
        </ButtonWithRole>
      </>
    )
  }

  // モーダル表示/非表示設定
  modalReEstimate () {
    this.setState({
      modalReEstimate : !this.state.modalReEstimate,
      modalEditEstimate : false,
      modalSendEstimate : false,
      modalAutoOrder : false,
    })
  }

  modalEditEstimate () {
    this.setState({
      modalReEstimate : false,
      modalEditEstimate : !this.state.modalEditEstimate,
      modalSendEstimate : false,
      modalAutoOrder : false,
    })
  }

  modalSendEstimate () {
    this.setState({
      modalReEstimate :false,
      modalEditEstimate : false,
      modalSendEstimate : !this.state.modalSendEstimate,
      modalAutoOrder : false,
    })
  }

  modalAutoOrder () {
    this.setState({
      modalReEstimate :false,
      modalEditEstimate : false,
      modalSendEstimate : false,
      modalAutoOrder : !this.state.modalAutoOrder,
    })
  }

  // 再見積/見積もり編集用のダイアログ
  dialog_defines() {
    // console.log(this.state.reEstimateData)
    // TODO 判定を汎用的にすること
    let disabled = (this.state.reEstimateData && this.state.reEstimateData.estimate_all_copy_flag == 1)? false: true

    return (
      <>
        <DialogCalcelConfirm
          ref={this.dialogCancelConfirm}
          data={this.state.dialogCancelConfirmData}
          positive={true}
          refreshCallback={this.search}
        />
        <MemoPopup 
          ref={this.memoPopup} 
          data={this.state.memoPopupData} 
          positive={true}
          updateMemo = {(data) => this.updateMemo(data)}
          {...this.props}
        />
        <AddMemoPopup 
          ref={this.addMemoPopup} 
          data={this.state.addMemoPopupData}
          positive={true}
          {...this.props}
          updateMemo = {(data, isOrderMemo) => {this.updateEstimateMemo(data, isOrderMemo)}}
          name={this.state.addMemoPopupData.isOrderMemo ? "ESTIMATE__order_memo" : "ESTIMATE__supplier_memo"}
        />
        <DialogCustomerRequestFileDownload
          ref={this.dialogCustomerRequestFile}
          data={this.state.dialogCustomerRequestFileData}
          positive={false}
          negative_label="閉じる"
          //refreshCallback={this.search}
        />
       {/* 再見積 */}
       <Modal isOpen={this.state.modalReEstimate} toggle={this.modalReEstimate}>
          <ModalHeader className="justify-content-center" toggle={this.modalReEstimate}>
            {this.state.editRoutemapFlag?(<>再見積もりを行います。<br/>経路情報は破棄されます。<br/>よろしいですか？</>):(<>再見積もりを行います。よろしいですか？</>)}
          </ModalHeader>
          <ModalBody>
          <Card>
            <CardBody>
              <label>
                  <Input type="checkbox" name="editRoutemap"  disabled={disabled} id="editRoutemap" checked={this.state.editRoutemapFlag} onChange={()=>this.setState({editRoutemapFlag:!this.state.editRoutemapFlag})} />&nbsp;
                  経路図を編集する
              </label>
            </CardBody>
          </Card>
          </ModalBody>
          <ModalFooter>
            <Button onClick={()=>this.modalReEstimate()}>
              いいえ
            </Button>
            &nbsp;
            <Button onClick={()=>this.reEstimate()}>
              はい
            </Button>
          </ModalFooter>
        </Modal>
       {/* 見積編集 */}
        <Modal isOpen={this.state.modalEditEstimate} toggle={this.modalEditEstimate}>
          <ModalHeader className="justify-content-center" toggle={this.modalEditEstimate}>
            {this.state.editRoutemapFlag?(<>見積編集を行います。<br/>経路情報は破棄されます。<br/>よろしいですか？</>):(<>見積編集を行います。よろしいですか？</>)}
          </ModalHeader>
          <ModalBody>
          <Card>
            <CardBody>
              <label>
                  <Input type="checkbox" name="editRoutemap" id="editRoutemap" checked={this.state.editRoutemapFlag} onChange={()=>this.setState({editRoutemapFlag:!this.state.editRoutemapFlag})} />&nbsp;
                  経路図を編集する
              </label>
            </CardBody>
          </Card>
          </ModalBody>
          <ModalFooter>
            <Button onClick={()=>this.modalEditEstimate()}>
              いいえ
            </Button>
            &nbsp;
            <Button onClick={()=>this.editEstimate()}>
              はい
            </Button>
          </ModalFooter>
        </Modal>
        {/* 見積送信 */}
        <Modal isOpen={this.state.modalSendEstimate} toggle={this.modalSendEstimate}>
          <ModalHeader className="justify-content-center" toggle={this.modalSendEstimate}>
            調査見積を送付します。よろしいですか？
          </ModalHeader>
          <ModalBody>
              {(this.state.sendEstimateData.values.want_guide_type != "1" || this.state.sendEstimateData.values.want_guide_type_subcontract != "1") ?
              (<>
              <InputCheckBox 
                label="FAXを自動送信しない"
                name="TEMP__no_send_fax" 
                validateCallback={this.validateCallbackForSend} 
                checkedValue={true}
                uncheckedValue={false}
                rootData={this.state.sendEstimateData}
              // disabled={!Boolean(this.state.sendEstimateData.values.customer_system_use_flag)}
              />
              <br />
              </>):""
               }


          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={()=>this.modalSendEstimate()}>
            いいえ
            </Button>
            <Button onClick={()=>{
              this.modalSendEstimate(); 
              this.sendEstimate(); 
              }}>
              はい
            </Button>
          </ModalFooter>
        </Modal>
        {/* 見積送信 */}
        <Modal isOpen={this.state.modalAutoOrder} toggle={this.modalAutoOrder}>
          <ModalHeader className="justify-content-center" toggle={this.modalAutoOrder}>
            本件は自動発注する設定となっております。
          </ModalHeader>
          <ModalBody>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={()=>this.modalAutoOrder()}>
            閉じる
            </Button>
            <Button onClick={()=>{
              this.modalAutoOrder(); 
              this.autoOrder(); 
              }}>
              自動発注
            </Button>
          </ModalFooter>
        </Modal>
        <DialogSurveyCsvDownload
          ref={this.dialogSurveyCsvDownload} 
          {...this.props}
          dialogTitle = {this.state.dialogTitle}
          user_list = {this.state.landmark_user}
          search_params = {() => this.search_params()}
          positive={true}
          default_footer={true}
        />
      </>
    );
  }

  // 見積送付ダイアグ用validateCallback
  validateCallbackForSend(newData, callback=()=>{}){
    // console.log("sendEstimateData:startA")
    // console.log(this.state.sendEstimateData)
    // console.log("sendEstimateData:end")

    const sendEstimateData = this.state.sendEstimateData;
    this.setState({
      sendEstimateData:{
        ...sendEstimateData,
        ...newData,
        values:{
          ...newData.values,
        },
        errors: {
          ...newData.errors,
        }
      }
    })
  }

 async updBoxstatus(estimateRowDatas, sendEstimateData, cu_file_regist,auto_order_flag=false) {
    try {
      const url = "/api/request/" + sendEstimateData.ulid;
      
      const estimateDatas = estimateRowDatas.map(row => {
          if(auto_order_flag == true){
          row.estimate_status = ESTIMATE_STATUS.SEND_SERVEY
          row.order_box_status= ORDER_BOX_STATUS.NOT_YET
          row.cu_file_regist = cu_file_regist ? 1 : 0
        }else{
          row.estimate_status = ESTIMATE_STATUS.SEND_SERVEY;
          row.purchase_order_box_status = 0;
          row.cu_file_regist = cu_file_regist ? 1 : 0;
        }
        return row;

      })

      console.log("estimateDatas",estimateDatas);

      const params = {
        request_box_status: REQUEST_BOX_STATUS.COMPLETE,
        request_update_timestamp: sendEstimateData.update_timestamp,
        estimates: estimateDatas,
      };

      const patchRes = await new Promise((resolve, reject) => {
        Request.patch(url, params, res => {
          res.Code === 200 ? resolve(res) : reject(res);
        }, err => {reject(err)},undefined, true, false);
      });

      return patchRes;

    } catch (err) {
      Request.setProgress(0);
      throw err;
    }
  }


  /**  見積送付処理
   * C10_MAIL_調査見積送付状
   * C10_FAX_調査見積送付状
   * C10_SMS_調査見積送付状
   * C40_SMS_調査見積通知
   * C40_MAIL_調査見積通知
   */
  async sendEstimate(){
    try {
      // TODO入力チェック
      const sendEstimateData = this.state.sendEstimateData.values;
      console.log("sendEstimateData:start")
      console.log(sendEstimateData)

      // 見積を取得する
      const estimateRowDatas = await new Promise((resolve, reject)=>{
        var url = '/api/estimate';
        let params = {
            request_natural_id: sendEstimateData.request_natural_id
        };
        Request.get(url, params, res => resolve(res.data), err=> {reject(err)})
      })
      // console.log("estimateRowDatas")
      // console.log(estimateRowDatas)
    
      Request.setProgress(10, undefined, GetMessage(2436))
      // カスタマ-システムのユーザはアプリに通知するので通知を省力する
      const useCustomerSystem = sendEstimateData.customer_system_use_flag === 1 && sendEstimateData.b_customer_system_use_flag === 1 ? true : false;
      // fax
      const sendUploadNotification = sendEstimateData.send_upload_notification;
      const {
        want_guide_type,
        want_guide_type_subcontract,
        customer_natural_id,
        customer_branch_natural_id,
        customer_user_natural_id,
        project_natural_id,
        request_natural_id,
        subcontract_customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        user_branch_natural_id,
        no_send_fax,
      } = sendEstimateData;

      const ESTIMATE__latest_pdf_route_url = estimateRowDatas[0].latest_pdf_route_file_id
      const ESTIMATE__latest_pdf_survey_url= estimateRowDatas.map((data)=>{
        const result =  data.contract_pdf_url != null ? data.latest_pdf_survey_file_id + "," + data.contract_pdf_url : data.inhouse1_pdf_url != null ? data.inhouse1_pdf_url + "," + data.latest_pdf_survey_file_id : data.latest_pdf_survey_file_id
        return result
      }).join(',')

      const ESTIMATE__latest_pdf_route_sheet = estimateRowDatas[0].latest_pdf_route_url
      const ESTIMATE__latest_pdf_survey_sheet = estimateRowDatas.map((data)=>{
        let result = {};
        result["contract_pdf_url"] = data.contract_pdf_url != null ? data.contract_pdf_url : undefined;
        result["latest_pdf_survey_url"] = data.latest_pdf_survey_url != null ? data.latest_pdf_survey_url : undefined;
        result["inhouse1_pdf_url"] = data.inhouse1_pdf_url != null ? data.inhouse1_pdf_url : undefined;
        result["estimate_id"] = data.id;
        result["estimate_natural_id"] = data.estimate_natural_id;
        return result
      })


      const estimateCommonParams = await Request.getEstimateCommon({
        customer_branch_natural_id,
        customer_user_natural_id,
        project_natural_id,
        request_natural_id,
        subcontract_customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        estimateObject: estimateRowDatas[0],
        user_branch_natural_id
      })

      // console.log("estimateCommonParams")
      // console.log(estimateCommonParams)
      
      const {
        PROJECT__send_destination_type,
      } = estimateCommonParams.object_project

      // 元請案内通知設定
      const send_setting = (PROJECT__send_destination_type  == 0 || PROJECT__send_destination_type  == 2)
      // 下請案内通知設定
      const subcon_send_setting = (PROJECT__send_destination_type  == 1 || PROJECT__send_destination_type  == 2)

      const isMailAllowed = (
        ((want_guide_type=="1"||want_guide_type=="0") && send_setting)
        || ((want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0") && subcon_send_setting)
      );
          
      const isSmsAllowed = (
          send_setting && (estimateCommonParams.object_customer.CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && estimateCommonParams.object_customer.CUSTOMER_USER__customer_user_tel)
          || subcon_send_setting && (estimateCommonParams.object_customer_subcontract.CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && estimateCommonParams.object_customer_subcontract.CUSTOMER_USER__customer_user_tel)
          || estimateCommonParams.object_project.PROJECT__site_customer_user_tel
        );

      const isFaxAllowed = !no_send_fax && ( 
        ((want_guide_type=="2"||want_guide_type=="0") && send_setting) 
        || ((want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0") && subcon_send_setting) 
      )

      let cu_file_regist = false
      
      let messageNo = [2417];
      Request.setProgress(30, `見積作成中`, GetMessage(2436))
      // console.log("C40",useCustomerSystem,sendEstimateData.register_type)

      if(sendEstimateData.register_type == 1 && useCustomerSystem){
        let c40Mail = isMailAllowed 
          ? await new Promise((resolve, reject)=>{
          const mailUrl = '/api/pout/C40_MAIL'
          const mailParams = {
            ...estimateCommonParams,
            send_destination_type: 0, // C40は元請けのみ通知
            want_guide_type,
            want_guide_type_subcontract,
            format_url : GoogleDrive.getFormatUrl(format_url.C40_MAIL),
          }
          // console.log("mailParams")
          // console.log(mailParams)
          Request.post(mailUrl, mailParams,  res => resolve(res), err=> reject(err))
          })
          :{Code:200}
        
        let isPushAllowedCust = estimateCommonParams.object_customer.CUSTOMER_USER__notification_flag=="1" ? true : false;
        let isSmsAllowedCust = (estimateCommonParams.object_customer.CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && estimateCommonParams.object_customer.CUSTOMER_USER__customer_user_tel) ? true : false;
        if(isPushAllowedCust){
          isSmsAllowedCust = false;
        }
        // 2520 現場担当者
        if(estimateCommonParams.object_project.PROJECT__site_customer_user_tel){
          isSmsAllowedCust = true;
        }
        let c40Sms = isSmsAllowedCust || isPushAllowedCust
          ? await new Promise((resolve, reject)=>{
              const smsUrl = '/api/pout/C40_SMS'
              const smsParams = {
                ...estimateCommonParams,
                send_destination_type : 0, // C40は元請けのみ通知
                want_guide_type : want_guide_type,
              want_guide_type_subcontract:want_guide_type_subcontract,
              format_url:GoogleDrive.getFormatUrl(format_url.C40_SMS),
              push_flag: isPushAllowedCust ? 1 : 0,
            }
            Request.post(smsUrl, smsParams, res => resolve(res), err=> reject(err))
          })
          :{Code:200}
        console.log(c40Mail,c40Sms,isMailAllowed,isSmsAllowedCust,isPushAllowedCust)
        if(c40Mail.Code == 200 && c40Sms.Code == 200){
          let report_name = "C01_PDF"
          switch(customer_natural_id) {
            // アイダ設計
            case this.customerUseCustomizedEstimate:
              report_name = "Y09_PDF"
              break;
            // 東建コーポレーション
            case this.customerUseCustomizedEstimateForTouken:
              report_name = "Y12_PDF"
              break;
            // 大成建設ハウジング独自帳票
            case this.customerUseCustomizedEstimateForTaiseiHousing:
              // 東海・九州
              if(this.customerUseCustomizedEstimateForTaiseiHousingBranch.includes(customer_branch_natural_id)) {
                report_name = "Y15_PDF"
              // 近畿
              }else if(this.customerUseCustomizedEstimateForTaiseiHousingBranch2.includes(customer_branch_natural_id)){
                report_name = "Y16_PDF"
              }
          }       

          cu_file_regist = await new Promise((resolve, reject)=>{
            Request.setProgress(50, `ファイル連携中`)

            const cuUrl = '/api/cufile'
            const cuParams = {
              ...estimateCommonParams,
              ESTIMATE__latest_pdf_survey_url:ESTIMATE__latest_pdf_survey_sheet,
              ESTIMATE__latest_pdf_route_url:ESTIMATE__latest_pdf_route_sheet,
              customer_system_use_flag:useCustomerSystem,
              report_name
            }
            
            Request.post(cuUrl, cuParams, res=> {
              if (res.Code >= 800) {
                reject(undefined)
              }
              resolve(res)
            }, err=> reject(err))
          })
          Request.setProgress(80, `ステータス更新中`)
          if(c40Mail.Code == 200 && c40Sms.Code == 200 && cu_file_regist.Code == 200){

            const res = await this.updBoxstatus(estimateRowDatas,sendEstimateData, cu_file_regist)
            console.log(res);

            Request.setProgress(90, `送付開始`)
            const sendMail = isMailAllowed && c40Mail && cu_file_regist && new Promise((resolve, reject)=>{
              const sendMailUrl = '/api/send/MAIL'
              const sendMailParams = c40Mail.data
              Request.post(sendMailUrl, sendMailParams, res=> {
                messageNo.push(2543);
                resolve(res)
              }, err=> reject(err))
            })  
            window.open(`https://mail.google.com/mail/u/0/#drafts`);
            console.log("c40Sms",c40Sms)
            const sendPush = isPushAllowedCust && c40Sms && cu_file_regist && new Promise((resolve, reject)=>{
              const sendSmsUrl = '/api/send/PUSH'
              c40Sms.data && c40Sms.data.forEach((smsData) => {
                if( smsData.type == "push"){
                  const sendPushParams = {...smsData,customer_user_id:estimateCommonParams.object_customer.CUSTOMER_USER__id}
                  // console.log("sendPushParams",sendPushParams)
                  Request.post(sendSmsUrl, sendPushParams, res=> resolve(res), err=> reject(err))
                }
              })
            }) 

            const resultSms = isSmsAllowedCust && c40Sms && cu_file_regist && await new Promise((resolve, reject)=>{
              const sendSmsUrl = '/api/send/SMS'
              c40Sms.data && c40Sms.data.forEach((smsData) => {
                // console.log(smsData)
                if( smsData.type == "sms"){
                  if (smsData.site_flag == true) {
                    if (smsData.site_error == true) {
                      resolve({Code: 2631})
                    }else{
                      Request.post(sendSmsUrl, smsData, res => {
                        if (res.Data && res.Data.sms_status == 'accepted'){
                          resolve({Code: 200})
                        }else{
                          resolve({Code: 2631, data: res.Data})
                        }
                      }, err => {
                        resolve({Code: 2631, data: err})
                      }, undefined, true, false)
                    }
  
                  } else {
                    Request.post(sendSmsUrl, smsData, res => {}, err => {}, undefined, true, false)
                  }
                }
              })
            }) 
            console.log("resultSms",resultSms)
            if ( resultSms.Code == 200){
              Request.setProgress(0)
              this.props.alertModal.current.confirmCheck({
                title: "処理完了",
                messageNo: messageNo,
                closeBtn: false
              }, ()=>this.search(), false)          
            } else {
              Request.setProgress(0)
              console.log(resultSms);
              let title = "エラー"
              let message = GetMessage(2631)
              if (resultSms.data && resultSms.data.sms != "") {
                message = message + "<br />\n" + resultSms.data.sms
              }
              this.props.alertModal.current.confirmCheck({
                title: title,
                message: message ,
                closeBtn: false
              }, ()=>this.search(), false)
            }
            
            // resolve(res)
          }
        }
      }

      const fax = estimateCommonParams.object_customer.CUSTOMER_BRANCH__customer_branch_fax ? estimateCommonParams.object_customer.CUSTOMER_BRANCH__customer_branch_fax : ''
      const subcon_fax = estimateCommonParams.object_customer_subcontract.CUSTOMER_BRANCH__customer_branch_fax ? estimateCommonParams.object_customer.CUSTOMER_BRANCH__customer_branch_fax : ''

      if(sendEstimateData.register_type == 0) {
        console.log("c10Mail00:A")
        let c10Mail = (
          ((want_guide_type=="1"||want_guide_type=="0") && send_setting)
          || ((want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0") && subcon_send_setting
          ))
          ? new Promise((resolve, reject)=>{
            console.log("c10Mail00:B")
          // 依頼元担当者のメールアドレスがNullでは無い AND 「メールを送信する」（REQUEST__want_guide_type）となっていること
            const mailUrl = '/api/pout/C10_MAIL'

            var mailParams = {
              ...estimateCommonParams,
              // 顧客システムを利用する場合は既存（C10調査見積送付状）帳票は元請け送信しない
              // send_destination_type: useCustomerSystem ? 1 : PROJECT__send_destination_type,
              send_destination_type: PROJECT__send_destination_type,
              want_guide_type,
              want_guide_type_subcontract,
              format_url:GoogleDrive.getFormatUrl(format_url.C10_MAIL),
              ESTIMATE__latest_pdf_survey_url,
              ESTIMATE__latest_pdf_route_url,
            }

            console.log("c10Mail00:mailParams")
            console.log(mailParams)

            Request.post(mailUrl, mailParams, res=>{
              if (res.Code !=200){
                console.log("c10Mail00:reject")
                console.error(res)
                reject()
              }else{
                resolve(res)
              }
            }, err=>{
              console.log(err)
              reject(err)
            })
          }
        )
        :{Code:200}

        // #1034　既存：DBに設定された案内設定　→　新：手動にて設定した案内設定を優先
        let c10Fax = !no_send_fax && (
          // ((want_guide_type=="2"||want_guide_type=="0") && send_setting && fax.length>0 && useCustomerSystem == false) 
          ((want_guide_type=="2"||want_guide_type=="0") && send_setting && fax.length>0) 
          || ((want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0") && subcon_send_setting && subcon_fax.length>0))
          ? new Promise((resolve, reject)=>{
          const faxUrl = '/api/pout/C10_FAX'

          var faxParams = {
            ...estimateCommonParams,
            // 顧客システムを利用する場合は既存（C10調査見積送付状）帳票は元請け送信しない
            // send_destination_type : useCustomerSystem ? 1 : PROJECT__send_destination_type,
            send_destination_type : PROJECT__send_destination_type,
            want_guide_type,
            want_guide_type_subcontract,
            format_url : GoogleDrive.getFormatUrl(format_url.C10_FAX),
            ESTIMATE__latest_pdf_survey_url,
            ESTIMATE__latest_pdf_route_url
          }
          Request.post(faxUrl, faxParams, res=>{
            if (res.Code !=200){
              console.log("c10Fax:reject")
              console.error(res)
              reject()
            }else{
              resolve(res)
            }
          }, err=>{
            reject(err)
          })
        })
        :{Code:200}

        let c10Sms = isSmsAllowed 
          ? new Promise((resolve, reject)=>{
          const smsUrl = '/api/pout/C10_SMS'
          const smsParams = {
            ...estimateCommonParams,
            // 顧客システムを利用する場合は既存（C10調査見積送付状）帳票は元請け送信しない
            // send_destination_type: useCustomerSystem ? 1 : PROJECT__send_destination_type,
            send_destination_type: PROJECT__send_destination_type,
            want_guide_type:want_guide_type,
            want_guide_type_subcontract:want_guide_type_subcontract,
            format_url:GoogleDrive.getFormatUrl(format_url.C10_SMS),
            ESTIMATE__latest_pdf_survey_url,
            ESTIMATE__latest_pdf_route_url
          }
          Request.post(smsUrl, smsParams, res=>{
            if (res.Code !=200){
              console.log("c10Sms:reject")
              console.error(res)
              reject()
            }else{
              resolve(res)
            }
          }, err=>{
            reject(err)
          })
        })
        :{Code:200}

        Request.setProgress(30, `送付状作成中`, GetMessage(2436))
        const c1011Results = await Promise.all([c10Mail,c10Fax,c10Sms]).then(r=>r).catch((err)=>{
          console.log('catched err',err)
          Request.setProgress(0)
          return
        })

        c10Mail = c1011Results && c1011Results[0]
        c10Fax = c1011Results && c1011Results[1]
        c10Sms = c1011Results && c1011Results[2]
        
        console.log("c10Mail",c10Mail)
        console.log("c10Fax",c10Fax)
        console.log("c10Sms",c10Sms)

        if(c10Mail.Code == 200 && c10Fax.Code == 200 && c10Sms.Code == 200){

          Request.setProgress(70, `ステータス更新中`)

          const res = await this.updBoxstatus(estimateRowDatas,sendEstimateData, cu_file_regist)
          console.log(res);

          Request.setProgress(90, `送付開始`)

          // 顧客システム利用且つ送付先が元請けのみの場合は通知不要
          // if(!(useCustomerSystem && PROJECT__send_destination_type === 0)){
          const sendMailUrl = '/api/send/MAIL'
          c10Mail.Data&&c10Mail.Data.forEach((mailData)=>{
            Request.post(sendMailUrl, mailData, res=>{
              messageNo.push(2471);
            }, err=>{
            },undefined, true, false)
          })
      
          const sendFaxUrl = '/api/send/FAX'
          c10Fax.Data&&c10Fax.Data.forEach((faxData)=>{
            Request.post(sendFaxUrl, faxData, res=>{
            }, err=>{
            },undefined, true, false)
          })
          
          const sendSmsUrl = '/api/send/SMS'
          c10Sms.Data&&c10Sms.Data.forEach((smsData)=>{
            if( smsData.type == "sms" && smsData.site_flag == false){
              Request.post(sendSmsUrl, smsData, res=>{
              }, err=>{
              },undefined, true, false)
            }
          })
          // }
          if(((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0"))  
            ||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))){
            window.open(`https://mail.google.com/mail/u/0/#drafts`);
          }
          Request.setProgress(0)
          this.props.alertModal.current.confirmCheck({
            title: "処理完了",
            messageNo: messageNo,
            closeBtn: false
          }, ()=>this.search(), false)

        }


      }

    } catch (err) {
      Request.setProgress(0)
      console.log(err);
      this.props.alertModal.current.confirmCheck({
        title: "エラーが発生しました。",
        message: err.Message ? err.Message : "見積送付処理中にエラーが発生しました。",
        closeBtn: false,
        titleBtn: "閉じる"
      }, ()=>window.location.reload(), false)
    }
  }

  async autoOrder(){
    
    try{
      // TODO入力チェック
      const sendEstimateData = this.state.sendEstimateData.values;
      const {
        want_guide_type,
        want_guide_type_subcontract,
        customer_natural_id,
        customer_branch_natural_id,
        customer_user_natural_id,
        project_natural_id,
        request_natural_id,
        subcontract_customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        user_branch_natural_id,
        no_send_fax,
      } = sendEstimateData;

      // console.log("autoOrder:start")
      // console.log(sendEstimateData)

      // 見積を取得する
      Request.setProgress(20)
      const estimateRowDatas = await new Promise((resolve, reject)=>{
        var url = '/api/estimate';
        let params = {
            request_natural_id: sendEstimateData.request_natural_id
        };
        Request.get(url, params, res => resolve(res.data), err=> {reject(err)})
      })
      // console.log("estimateRowDatas")
      // console.log(estimateRowDatas)

      const estimateCommonParams = await Request.getEstimateCommon({
        customer_branch_natural_id,
        customer_user_natural_id,
        project_natural_id,
        request_natural_id,
        subcontract_customer_branch_natural_id,
        subcontract_customer_user_natural_id,
        estimateObject: estimateRowDatas[0],
        user_branch_natural_id
      })

      // console.log("estimateRowDatas",estimateCommonParams)

      let cu_file_regist = false

      const useCustomerSystem = sendEstimateData.customer_system_use_flag === 1 && sendEstimateData.b_customer_system_use_flag === 1 ? true : false;

      const ESTIMATE__latest_pdf_route_sheet = estimateRowDatas[0].latest_pdf_route_url
      const ESTIMATE__latest_pdf_survey_sheet = estimateRowDatas.map((data)=>{
        let result = {};
        result["contract_pdf_url"] = data.contract_pdf_url != null ? data.contract_pdf_url : undefined;
        result["latest_pdf_survey_url"] = data.latest_pdf_survey_url != null ? data.latest_pdf_survey_url : undefined;
        result["inhouse1_pdf_url"] = data.inhouse1_pdf_url != null ? data.inhouse1_pdf_url : undefined;
        result["estimate_id"] = data.id;
        result["estimate_natural_id"] = data.estimate_natural_id;
        return result
      })

      let report_name = "C01_PDF"
      switch(customer_natural_id) {
        // アイダ設計
        case this.customerUseCustomizedEstimate:
          report_name = "Y09_PDF"
          break;
        // 東建コーポレーション
        case this.customerUseCustomizedEstimateForTouken:
          report_name = "Y12_PDF"
          break;
        // 大成建設ハウジング独自帳票
        case this.customerUseCustomizedEstimateForTaiseiHousing:
          // 東海・九州
          if(this.customerUseCustomizedEstimateForTaiseiHousingBranch.includes(customer_branch_natural_id)) {
            report_name = "Y15_PDF"
          // 近畿
          }else if(this.customerUseCustomizedEstimateForTaiseiHousingBranch2.includes(customer_branch_natural_id)){
            report_name = "Y16_PDF"
          }
      }       
      console.log(useCustomerSystem)
      if(useCustomerSystem == true){
        Request.setProgress(50, `ファイル連携中`)      
        cu_file_regist = await new Promise((resolve, reject)=>{
          const cuUrl = '/api/cufile'
          const cuParams = {
            ...estimateCommonParams,
            ESTIMATE__latest_pdf_survey_url:ESTIMATE__latest_pdf_survey_sheet,
            ESTIMATE__latest_pdf_route_url:ESTIMATE__latest_pdf_route_sheet,
            customer_system_use_flag:useCustomerSystem,
            report_name
          }

          Request.post(cuUrl, cuParams, res=> {
            if (res.Code >= 800) {
              console.log(res)
              reject(undefined)
            }
            resolve(res)
          }, err=> {
            console.log(err)
            reject(err)
          })
            
        }).catch(err => {
          
          this.props.alertModal.current.confirmCheck({
            title: "エラーが発生しました。",
            message: "JESUSへの連携時にエラーが発生しました。<br/>見積ID：" + estimateRowDatas[0].estimate_natural_id ,
            closeBtn: false,
            titleBtn: "閉じる"
          }, ()=>this.search(), false)
          Request.setProgress(0)
          console.log(err)
    
          return false;
      
        })
        if(cu_file_regist.Code != 200){
          return false;
        }
      }
      
      Request.setProgress(80, `ステータス更新中`)
      let messageNo = [2417];
      // 依頼BOXステータスを完了
      const res = await this.updBoxstatus(estimateRowDatas, sendEstimateData, cu_file_regist, true)
      console.log(res);

      Request.setProgress(0)
      this.props.alertModal.current.confirmCheck({
        title: "処理完了",
        messageNo: messageNo,
        closeBtn: false
      }, ()=>this.search(), false)

    } catch (err) {
      Request.setProgress(0)
      console.log(err);
      this.props.alertModal.current.confirmCheck({
        title: "エラーが発生しました。",
        message: err.Message ? err.Message : "自動発注処理中にエラーが発生しました。",
        closeBtn: false,
        titleBtn: "閉じる"
      }, ()=>window.location.reload(), false)
    }
  }

  // 顧客メモ表示
  onClickOrderMemo(prop) {
    this.setState({
      addMemoPopupData : {
        values : prop,
        isOrderMemo: true,
        label: "顧客メモ"
      }
    }, () => { this.addMemoPopup.current.show() })
  }
　// 仕入先メモ表示
  onClickSupplierMemo(prop) {
    this.setState({
      addMemoPopupData : {
        values : prop,
        isOrderMemo: false,
        label: "仕入先メモ"
      }
    }, () => { this.addMemoPopup.current.show() })
  }
}
export class DialogCalcelConfirm extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '依頼キャンセルを確認済にします。よろしいですか？',
      request: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      }
    });
  }

  componentDidUpdate(prevProps){
    if(JSON.stringify(this.props) === JSON.stringify(prevProps))
      return;

    this.setState({
      request:this.props.data
    })
  }

  handleClickPositive() {
    const { values } = this.state.request;
    const cancelParams = {
      request_cancel_check_flag : 1, 
      request_cancel_check_date : moment().format("YYYY-MM-DDTHH:mm:ss"),
    }
    Request.put("/api/request/" + values.ulid, { ...values, ...cancelParams }, (res) => {
      this.props.refreshCallback();
      this.toggleModal();
    })
  }

  handleClickNegative(){
    this.toggleModal();
  }

  bodyContent(){
    return(<></>);
  }
}

// feature/1509 顧客システムファイルダウンロード
export class DialogCustomerRequestFileDownload extends DialogBase {
  constructor(props) {
    super(props);
    Object.assign(this.state, {
      title: '添付ファイルダウンロード',
      data: this.props.data,
      cuFiles : []
      // disablePositive:false
    });
    this.validateCallback = this.validateCallback.bind(this)

    this.CU_FILE_TYPE = 2;
    this.CU_FILE_DETAIL_TYPE = 201;
  }

  async componentDidUpdate(prevProps){
    const {CU_FILE_TYPE,CU_FILE_DETAIL_TYPE} = this

    if (prevProps.data !== this.props.data){

      // ファイル情報取得
      Request.get('/api/cufile', { ref_id : this.props.data.values.id, file_type: CU_FILE_TYPE }, res => {
        this.setState({
          cuFiles : res.Data
        })
      })

      this.setState({
        data: {
          values:{
            ...this.props.data.values,
            send_upload_notification:false
          },
          errors:{
            invoice:[GetMessage(2024)]
          },
          requiredData:{
            invoice:[GetMessage(2024)],
          }
        },
      })
    }
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      data:{
        ...this.state.data,
        ...newData
      },
    }, ()=>callback())
  }

  handleClickNegative(){
    this.props.handleClickNegative && this.props.handleClickNegative();
    this.setState({
      data:{
        ...this.state.data,
      }
    })

    this.toggleModal()
  }
  bodyContent() {
    return (
      <>
        {this.state.cuFiles.map((file, index) => (
          <Row key={index}>
              <Col>
                <a className={file.status === 0 ? "disabled-link":""} href={`/api/gcs_download/${file.file_path}?d=${file.file_name}`} target="_blank">{file.file_name}</a>      
              </Col>
              {/*<Col>
                <Button onClick={()=>{this.handleDeleteLink(file.file_id)}}color="danger" size="sm" disabled={file.status === 0}>削除</Button>
                <Button onClick={()=>{this.handleReactivateLink(file.file_id)}} className="ml-3" color="secondary" size="sm" disabled={file.status === 1}>戻す</Button>
        </Col>*/}
          </Row>
        ))}
        <br/>
      </>
    );
  }
}


export default List;

export class DialogSurveyCsvDownload extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      csvData : [[]],
      dialogData : {
        values : {},
        errors : {},
        requiredData : {}
      }
    });

    this.csvDownloader = React.createRef();
    this.getListCsv = this.getListCsv.bind(this)
    this.validateCallback = this.validateCallback.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogTitle !== this.props.dialogTitle || prevState.modal !== this.state.modal){
      this.setState({
        title: this.props.dialogTitle+'をします。よろしいですか？',
        user_list : this.props.user_list,
        dialogData : {
          errors: {
            ...this.state.dialogData.errors
          }, 
        }
      });
    }
  }

  validate(){
    let message = getErrorCodes(this.state.dialogData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData
      }
    }, ()=>callback())
  }

  async getListCsv(){
    const search_params = {
      ...this.props.search_params()
    }
    const searched_data = await new Promise((resolve, reject)=> {
      Request.get(`/api/request/csv`, search_params , res => {
        console.log(res.Data)
        resolve(res.Data)
      })
    })

    const csvData = this.makeCsv(searched_data)
    return csvData
  }

  isNullOrUndefined(data){
    if(data === undefined || data === null){
      return true;
    }
    return false;
  }

  makeCsv(d){
    const csvData = d.reduce((acc, data) => {
      const matchedUser = this.props.user_list.find((singleUser)=>singleUser.id===data.lastupdate_user_id);
      const last_update_user_name = matchedUser ? matchedUser.label : "";

      acc.push([
        this.isNullOrUndefined(data.request_natural_id) ? "" : data.request_natural_id, // 案件ID
        this.isNullOrUndefined(data.request_box_status) ? "" : FormatCode.decode("cst_request_box_status",data.request_box_status), // BOXステータス
        this.isNullOrUndefined(data.estimate_deadline) ? "" : moment(data.estimate_deadline).format("YYYY/MM/DD"), // 見積提出期限
        this.isNullOrUndefined(data.request_type) ? "" : FormatCode.decode("cst_request_type",data.request_type), // 依頼種別
        (this.isNullOrUndefined(data.car_qty) ? 0 : data.car_qty) +  // 台数
          (this.isNullOrUndefined(data.light_truck_qty) ? 0 : data.light_truck_qty) + 
          (this.isNullOrUndefined(data.truck_qty) ? 0 : data.truck_qty) + 
          (this.isNullOrUndefined(data.other_car_qty) ? 0 : data.other_car_qty),
        this.isNullOrUndefined(data.customer_name) ? "" : data.customer_name, // 顧客会社名
        this.isNullOrUndefined(data.customer_branch_name) ? "" : data.customer_branch_name, // 顧客支店名
        this.isNullOrUndefined(data.customer_user_name) ? "" : data.customer_user_name, // 顧客担当者名
        this.isNullOrUndefined(data.customer_user_tel) ? "" : data.customer_user_tel, // 顧客担当者：携帯電話番号
        this.isNullOrUndefined(data.customer_user_tel2) ? "" : data.customer_user_tel2, // 顧客担当者：固定電話番号
        this.isNullOrUndefined(data.site_name) ? "" : data.site_name, // 現場名
        this.isNullOrUndefined(data.construction_number) ? "" : data.construction_number, // 工事番号
        (this.isNullOrUndefined(data.site_prefecture) ? "" : FormatCode.decode("prefecture",data.site_prefecture) + // 現場住所
        (this.isNullOrUndefined(data.site_city) ? "" : data.site_city) +
        (this.isNullOrUndefined(data.site_address) ? "" : data.site_address)),
        this.isNullOrUndefined(data.site_customer_user_name) ? "" : data.site_customer_user_name, // 現場担当者名
        this.isNullOrUndefined(data.site_customer_user_tel) ? "" : data.site_customer_user_tel, // 現場担当者電話番号
        this.isNullOrUndefined(data.web_user_name) ? "" : data.web_user_name, // 調査担当者
        this.isNullOrUndefined(data.survey_account_user_lock_flag) ? 0 : data.survey_account_user_lock_flag, // 調査担当者ロックフラグ
        this.isNullOrUndefined(data.update_timestamp) ? "" : moment(data.update_timestamp).format("YYYY/MM/DD HH:mm:ss"), // 最終更新者情報：更新日
        last_update_user_name, // 最終更新者情報：更新者
        this.isNullOrUndefined(data.first_estimate_send_date) ? "" : moment(data.first_estimate_send_date).format("YYYY/MM/DD"), // 見積依頼受付日
        this.isNullOrUndefined(data.want_start_date) ? "" : moment(data.want_start_date).format("YYYY/MM/DD"), // 利用期間：開始日
        this.isNullOrUndefined(data.want_end_date) ? "" : moment(data.want_end_date).format("YYYY/MM/DD"), // 利用期間：終了日
        this.isNullOrUndefined(data.customer_other_request) ? "" : data.customer_other_request, // 顧客からの要望
        this.isNullOrUndefined(data.customer_branch_system_memo) ? "" : data.customer_branch_system_memo, // 顧客支店メモ
        this.isNullOrUndefined(data.subcontract_customer_name) ? "" : data.subcontract_customer_name, // 顧客会社名（下請先）
        this.isNullOrUndefined(data.subcontract_customer_branch_name) ? "" : data.subcontract_customer_branch_name, // 顧客支店名（下請先）
        this.isNullOrUndefined(data.subcontract_customer_user_name) ? "" : data.subcontract_customer_user_name, // 顧客担当者名（下請先）
        this.isNullOrUndefined(data.subcontract_customer_user_tel) ? "" : data.subcontract_customer_user_tel, // 顧客担当者：携帯電話番号（下請先）
        this.isNullOrUndefined(data.subcontract_customer_user_tel2) ? "" : data.subcontract_customer_user_tel2 // 顧客担当者：顧客電話番号（下請先）
        // this.isNullOrUndefined(data.estimate_natural_id) ? "" : data.estimate_natural_id,
        // this.isNullOrUndefined(data.payment_finish_date) ? "" : moment(data.payment_finish_date).format("YYYY/MM/DD"),
        // this.isNullOrUndefined(data.user_branch_name) ? "" : data.user_branch_name,
        // this.isNullOrUndefined(data.customer_name) ? "" : data.customer_name,
        // this.isNullOrUndefined(data.customer_branch_name) ? "" : data.customer_branch_name,
        // this.isNullOrUndefined(data.customer_user_name) ? "" : data.customer_user_name,
        // this.isNullOrUndefined(data.construction_number) ? "" : data.construction_number,
        // (FormatCode.decode("prefecture",data.site_prefecture)
        // + (this.isNullOrUndefined(data.site_city) ? "" : data.site_city)
        // + (this.isNullOrUndefined(data.site_address) ? "" : data.site_address)),
        // this.isNullOrUndefined(data.site_name) ? "" : data.site_name,
        // this.isNullOrUndefined(data.quote_available_start_date) ? "" : moment(data.quote_available_start_date).format("YYYY/MM/DD"),
        // this.isNullOrUndefined(data.quote_available_end_date) ? "" : moment(data.quote_available_end_date).format("YYYY/MM/DD"),
        // this.isNullOrUndefined(data.payment_user_memo) ? "" : data.payment_user_memo,
        // // 2023/08/28 インボイス対応
        // this.map_invoice_data(data,"survey_cost_parking_rent","payment_type"),
        // this.map_invoice_data(data,"survey_cost_parking_rent","business_type"),
        // this.map_invoice_data(data,"survey_cost_parking_rent","registration_number"),
        // this.map_invoice_data(data,"survey_cost_commission","payment_type"),
        // this.map_invoice_data(data,"survey_cost_commission","business_type"),
        // this.map_invoice_data(data,"survey_cost_commission","registration_number"),
        // this.map_invoice_data(data,"survey_cost_key_money","payment_type"),
        // this.map_invoice_data(data,"survey_cost_key_money","business_type"),
        // this.map_invoice_data(data,"survey_cost_key_money","registration_number"),
        // this.isNullOrUndefined(data.payment_amt) ? 0 : data.payment_amt,
        // this.isNullOrUndefined(data.payment_estimate_amt) ? 0 : data.payment_estimate_amt,
        // this.isNullOrUndefined(data.quote_total_amt) ? 0 : data.quote_total_amt,
        // this.isNullOrUndefined(data.supplier_name) ? "" : data.supplier_name,
        // this.isNullOrUndefined(data.payment_bank_account_number) ? "" : data.payment_bank_account_number,
        // this.isNullOrUndefined(data.supplier_tel) ? "" : data.supplier_tel,
        // this.isNullOrUndefined(data.survey_parking_name) ? "" : data.survey_parking_name,
        // this.isNullOrUndefined(data.quote_capacity_qty) ? 0 : data.quote_capacity_qty,
        // this.isNullOrUndefined(data.quote_cost_total_amt) ? 0 : data.quote_cost_total_amt,
        // this.isNullOrUndefined(data.quote_cost_adjustment) ? 0 : data.quote_cost_adjustment,
        // this.isNullOrUndefined(data.add_cost_amt) ? 0 : data.add_cost_amt,
        // this.isNullOrUndefined(data.quote_cost_security_deposit_total_amt) ? 0 : data.quote_cost_security_deposit_total_amt,
        // this.isNullOrUndefined(data.add_cost_security_deposit_amt) ? 0 : data.add_cost_security_deposit_amt,
        // this.isNullOrUndefined(data.due_day_rule) ? "" : data.due_day_rule,
        // this.isNullOrUndefined(data.payment_type) ? "" : data.payment_type,
      ])
      return acc
    }, [[...SURVEY_CSV.HEADER]])
    return this.wrappingQuote(csvData);
  }

  wrappingQuote = (dataArray) => {
    return dataArray.map(data => 
      data.map((data => {
        if(data===""){
          return data
        } else {
          return '"'+data+'"'
      }})
    ))
  }

  bodyContent() {
    return (
      <> 
        <div className="modal-box">
          <Button color="secondary" onClick={()=> {this.handleClickNegative()}}>キャンセル</Button>
          <Button color="info" onClick={async ()=> {
            const csvData = await this.getListCsv();
            this.setState({
              csvData : csvData
            }, () => {
              this.csvDownloader.current.handleClick()
              this.handleClickNegative();
            })
          }}>OK</Button>
        </div>
        <Row>
          <CsvDownloader
            noHeader={true}
            filename={`survey_list_${moment().format("YYYYMMDD_HHmmss")}`}
            datas={this.state.csvData}
            separator=","
            ref={this.csvDownloader}
          >
            <div></div>
          </CsvDownloader>
        </Row>
      </>
    );
  }
}